export { default } from "./CategoryBottomBanner.jsx";
